<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="userId">
        <span slot="label"><a-tooltip>{{ $t('用户id') }}<template slot="title">{{ $t('用户id') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.userId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'用户id'"/>
      </a-form-model-item>
      <a-form-model-item prop="type">
        <span slot="label"><a-tooltip>{{ $t('类型 1 红包 2 转账') }}<template
          slot="title">{{ $t('类型 1 红包 2 转账') }}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="targetUserId">
        <span slot="label"><a-tooltip>{{ $t('目标用户id') }}<template
          slot="title">{{ $t('目标用户id') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.targetUserId" style="width: 100%" :max="9999999"
                        :placeholder="$t('请输入')+'目标用户id'"/>
      </a-form-model-item>
      <a-form-model-item prop="transferAmount">
        <span slot="label"><a-tooltip>{{ $t('转账金额') }}<template
          slot="title">{{ $t('转账金额') }}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="receiveStatus">
        <span slot="label"><a-tooltip>{{ $t('状态 1 未接收 2 已接收 3 已退回') }}<template
          slot="title">{{ $t('状态 1 未接收 2 已接收 3 已退回') }}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="receiveTime">
        <span slot="label"><a-tooltip>{{ $t('接收时间') }}<template
          slot="title">{{ $t('接收时间') }}</template></a-tooltip> </span>
        <a-date-picker style="width: 100%" v-model="form.receiveTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="expireTime">
        <span slot="label"><a-tooltip>{{ $t('失效时间') }}<template
          slot="title">{{ $t('失效时间') }}</template></a-tooltip> </span>
        <a-date-picker style="width: 100%" v-model="form.expireTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item prop="remark">
        <span slot="label"><a-tooltip>{{ $t('备注') }}<template
          slot="title">{{ $t('备注') }}</template></a-tooltip> </span>
        <a-input v-model="form.remark" :maxLength="255" :placeholder="$t('请输入')+'备注'">
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['remark']"
            input-type="input"
            table-name="user_user_transfer"
            table-field="remark"
            :field-value="form.remark"/>
        </a-input>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getUserTransferRecord, addUserTransferRecord, updateUserTransferRecord} from '@/api/user/userTransferRecord'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";


export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
    LocaleFieldButton,
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        userId: null,
        type: null,
        targetUserId: null,
        transferAmount: null,
        receiveStatus: 0,
        receiveTime: null,
        expireTime: null,
        remark: null,
        localeFieldMap: {},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [{required: true, message: this.$t('用户id') + this.$t('不能为空'), trigger: 'blur'}],
        type: [{required: true, message: this.$t('类型 1 红包 2 转账') + this.$t('不能为空'), trigger: 'change'}],
        targetUserId: [{required: true, message: this.$t('目标用户id') + this.$t('不能为空'), trigger: 'blur'}]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        type: null,
        targetUserId: null,
        transferAmount: null,
        receiveStatus: 0,
        receiveTime: null,
        expireTime: null,
        remark: null,
        localeFieldMap: {},
      }

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUserTransferRecord({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateUserTransferRecord(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addUserTransferRecord(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
